import { ref } from 'vue';
import customerService from '@/services/customerService';
import type { Customer } from '@/types/customer';

export const useCustomerSelection = () => {
  const recentCustomers = ref<Customer[]>([]);
  const isLoading = ref(false);
  const error = ref<string | null>(null);

  const selectCustomer = (customer: Customer) => {
    return customer;
  };

  const clearCustomer = () => {
    return null;
  };

  const loadRecentCustomers = async () => {
    isLoading.value = true;
    error.value = null;
    try {
      recentCustomers.value = await customerService.getRecentCustomers(10);
    } catch (err) {
      console.error('Error loading recent customers:', err);
      error.value = 'Failed to load recent customers';
      recentCustomers.value = [];
    } finally {
      isLoading.value = false;
    }
  };

  const refreshRecentCustomers = async () => {
    await loadRecentCustomers();
  };

  return {
    recentCustomers,
    isLoading,
    error,
    selectCustomer,
    clearCustomer,
    loadRecentCustomers,
    refreshRecentCustomers,
  };
};
